import React, { useCallback } from 'react'
import { CheckBoxField } from '@sencha/ext-modern'

import { getMixedProps, handleValueChange } from '../blockPublic'
import { useEventHandler, useInstData } from 'tyan/public/hooks'

import Need2KnowDlg from './Need2KnowDlg'

const Need2Know = ({ config: { field, onChange: _onChange, initValues, changedValues, defaultStyle, that } }) => {
	const { props: { desc, title, content, delay, ...props } } = getMixedProps('_need2know', [defaultStyle, field])
	const { setState, me: { state: { edited } } } = useInstData()
	let { name, value, required } = field

	const handleChange = useCallback(handleValueChange(name, null, _onChange, 'bool'), [])

	const handleClick = useEventHandler((event, ...args) => {
		const handleAgree = (() => {
			!value && handleChange(null, true)
		})

		const handleDisagree = (() => {
			value && handleChange(null, false)
		})

		!edited && setState({ edited: true })
		event.preventDefault()
		Tyan.pubForm.showDialog(title, Need2KnowDlg,
			{ content, delay, value, onAgree: handleAgree, onDisagree: handleDisagree },
			{ width: '800px', maxHeight: '90%' }
			// { width: '95%', height: '95%'/* , maximizable:true,draggable:true */ }
		)
	})

	// const handleChange = useDelayHandleChange(
	// 	handleValueChange(field.name, initValues[field.name], onChange, 'number')
	// )

	// console.log('render', required && edited && !value ? '这是一个必填项' : '')
	return <CheckBoxField {...props}
		userCls='t-checkbox-need2know'
		checked={value} /* onChange={handlerCheckBoxChange(value)} */ boxLabel={desc}
		errorMessage={required && edited && !value ? '这是一个必填项' : ''}
		bodyAlign='start'
		listeners={{ click: { element: 'inputElement', fn: handleClick } }}
	/>
}

export default Need2Know